import { Component, Vue } from 'vue-property-decorator'
import { Feature } from '~/plugins/feature-flags'
import { NEWS_TICKER_TEST } from '~/plugins/feature-flags/variants'

@Component
export default class DashboardNewsTickerFeature extends Vue {
  getDashboardNewsTickerFeatureEnabled() {
    return this.$featureFlags?.isEnabled?.(Feature.DashboardNewsTicker)
  }

  getDashboardNewsTickerFeatureVariant() {
    return this.$featureFlags?.getVariant?.(Feature.DashboardNewsTicker)?.name
  }

  getDashboardNewsTickerFeatureVisible() {
    return (
      this.getDashboardNewsTickerFeatureEnabled() &&
      this.getDashboardNewsTickerFeatureVariant() === NEWS_TICKER_TEST
    )
  }
}
